import {
  loginAPIHeaders,
  otherAPIHeaders,
  uploadAPIHeaders,
  ssoHeaders,
} from "../shared-resources/dumpData";

export function getGeneralSettingsAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getGeneralSettings`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateGeneralSettingsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/updateGeneralSettings`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getRolesAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getResourceMgmtRoles`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getSkillsAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getResourceMgmtSkills`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getAdminDepartmentsAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getResourceMgmtDepartment`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateRolesAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/updateResourceMgmtRoles`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateSkillsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/updateResourceMgmtSkills`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateDepartmentsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/updateResourceMgmtDepartment`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getReportingManagersAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/dropdowns/getProjectManagersList`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getPrioritiesListAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/dropdowns/getPrioritiesList`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getProjectTypesListAPI() {
  return fetch(`${process.env.KIRKLAND_APP_API_URL}/dropdowns/getTypesList`, {
    method: "GET",
    headers: otherAPIHeaders,
  })
    .then((res) => res.json())
    .catch((err) => err);
}

export function getPMComponentSettingsAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/ProjectManagement/getComponentSettings`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updatePMComponentSettingsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/ProjectManagement/updateComponentSetting`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getPMFieldSettingsAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getPrjMgmtSettings`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updatePMFieldSettingsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/updatePrjMgmtSettings`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getRMComponentSettingsAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/ResourceManagement/getComponentSettings`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateRMComponentSettingsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/ResourceManagement/updateComponentSetting`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getRMFieldSettingsAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getResourceMgmtSettings`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateRMFieldSettingsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/updateResourseMgmtSettings`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getFMComponentSettingsAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/FinancialManagement/getComponentSettings`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateFMComponentSettingsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/FinancialManagement/updateComponentSetting`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getDirectEmployeeDetailsAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/FinancialManagement/getDirectEmployeeDetails`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateDirectEmployeeDetailsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/FinancialManagement/updateDirectEmployeeDetails`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getOtherDirectInhouseCostAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/FinancialManagement/getOtherDirectInhouseCost`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateOtherDirectInhouseCostAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/FinancialManagement/updateOtherDirectInhouseCost`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getVendorEmployeeDetailsAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/FinancialManagement/getVendorEmployeeDetails`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateVendorEmployeeDetailsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/FinancialManagement/updateVendorEmployeeDetails`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getVendorRelatedCostAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/FinancialManagement/getVendorRelatedCost`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateVendorRelatedCostAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/FinancialManagement/updateVendorRelatedCost`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getCapexRelatedExpenseAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/FinancialManagement/getCapexRelatedExpense`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateCapexRelatedExpenseAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/FinancialManagement/updateCapexRelatedExpense`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getEmploymentTypeListAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/dropdowns/getEmploymentTypeList`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getProjectStatusListAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/dropdowns/getProjectStatusList`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getFinanceMgmtSettingsAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getFinanceMgmtSettings`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateFinanceMgmtSettingsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/updateFinanceMgmtSettings`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getGeneralSettingsLocationAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getGeneralSettingsLocation`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateGeneralSettingsLocationAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/updateGeneralSettingsLocation`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function loginAPI(body, isAzure) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/login?isAzure=${isAzure}`,
    {
      method: "POST",
      headers: loginAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function logoutAPI() {
  return fetch(`${process.env.KIRKLAND_APP_API_URL}/user-setting/logout`, {
    method: "POST",
    headers: otherAPIHeaders,
  })
    .then((res) => res.json())
    .catch((err) => err);
}

export function forgotPasswordAPI(email) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/login/forgot-password`,
    {
      method: "GET",
      headers: { ...loginAPIHeaders, Email: email, accept: "*/*" },
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function validateOtpAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/login/validate-otp`,
    {
      method: "POST",
      headers: { ...loginAPIHeaders },
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function changePasswordOtpAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/login/create-new-password`,
    {
      method: "POST",
      headers: { ...loginAPIHeaders },
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getDelegatedResourceHistoryAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getDelegatedResourceHistory`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getResourceListForDelegationAPI(
  startDate = new Date(),
  endDate = new Date()
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getResourceListForDelegation`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify({ startDate, endDate }),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getResourceListForDelegationFromRoleAPI(
  startDate = new Date(),
  endDate = new Date()
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getResourceListForDelegationFromRole`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify({ startDate, endDate }),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function createDelegatedResourceHistoryAPI(body) {
  console.log(body);
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/saveDelegatedResourceHistory`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify([body]),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function newUserRegistrationAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/newUserRegistration`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function downloadCreateRoleTemplateExcelFileAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/downloadCreateRoleTemplateExcelFile`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}
export function createRoleFromExcelAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/createRoleFromExcel`,
    {
      method: "POST",
      headers: uploadAPIHeaders,
      body: body,
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}
export function downloadCreateDepartmentTemplateExcelFileAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/downloadCreateDepartmentTemplateExcelFile`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}
export function createDepartmentFromExcelAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/createDepartmentFromExcel`,
    {
      method: "POST",
      headers: uploadAPIHeaders,
      body: body,
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function getSSODataAPI(id) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getSSOResult?uniqueID=${id}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getEmailSettingsAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getEmailSettings`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateEmailSettingsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/updateEmailSettings`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function downloadUserAccessReportAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/downloadUserAccessReport`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function getUserAccessReportAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getUserAccessReport`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getActivityMasterSettingsAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getActivityMasterSettings`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function saveActivityMasterSettingsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/saveActivityMasterSettings`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getSubjectMasterSettingsAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getSubjectMasterSettings`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function saveSubjectMasterSettingsAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/saveSubjectMasterSettings`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function downloadActivityMasterAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/downloadActivityMaster`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function downloadSubjectMasterAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/downloadSubjectMaster`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function downloadDepartmentDetailsExcelFileAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/downloadDepartmentDetailsExcelFile`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function getUserDefaultSettingAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getUserDefaultSetting`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function createUpdateUserDefaultSettingAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/createUpdateUserDefaultSetting`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getUserAccessReportChartAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/getUserAccessReportChart`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getDefaultAvailableHoursAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/defaultAvailableHours?year=${year}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getFinancialYearsAPI() {
  return fetch(`${process.env.KIRKLAND_APP_API_URL}/user-setting/years`, {
    method: "GET",
    headers: otherAPIHeaders,
  })
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateDefaultAvailableHoursAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/defaultAvailableHours`,
    {
      method: "PUT",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function addYearForDefaultHoursAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/user-setting/defaultAvailableHours`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
